import { useSharedSafariContext } from 'provider/ShareSafariProvider';
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';

const BannerSafari = () => {
    const { safariViewLoading, safariViewData } = useSharedSafariContext();
    return (
        <>
            <section className="banner_section-inner packagebnner position-relative">
                <picture className="position-relative">
                    <source srcSet={"/img/baneer1719164625.jpg"} media="(max-width:576px)" type="image/jpg" />
                    <img src="/img/baneer1719164625.jpg" className="d-block w-100 banner_search" alt="banner" type="image/jpg" loading="lazy" />
                </picture>
                <div className="banner_searchBox">
                    <Container>
                        <Row>
                            <Col md={12}>
                                <div className="headingBnner_inner">
                                    {safariViewLoading ?<h1> <Skeleton width={200} height={35} /></h1>
                                        : <h1>{safariViewData?.types === "Fixed Departure" ? "Fixed Departure" : "Shared Safari"}</h1>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Container>

                </div>
            </section>
        </>
    )
}

export default BannerSafari
